import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/autoplay";


const AVATAR_COLORS = ["#00c896","#0f2040","#3b82f6","#8b5cf6","#f59e0b","#ef4444"];

const testimonials = [
  { id: 1, source: "G2",     rating: "5.0", color: AVATAR_COLORS[0],
    content: '"TrustEngine cut our onboarding drop-off by 40%. The eKYC API is blazing fast and the face match accuracy is genuinely exceptional."',
    name: "Rian Hidayat",   designation: "CEO - Aggre Capital" },
  { id: 2, source: "Clutch", rating: "5.0", color: AVATAR_COLORS[1],
    content: '"We integrated TrustEngine in under 2 days. The document OCR handles even low-quality photos reliably. Outstanding developer support."',
    name: "Sarah Chen",     designation: "VP Engineering - PayCircle" },
  { id: 3, source: "G2",     rating: "5.0", color: AVATAR_COLORS[2],
    content: '"Fraud attempts dropped 60% after deploying TrustEngine\'s liveness detection. The anti-spoofing is genuinely state-of-the-art."',
    name: "Reza Adiputra",  designation: "Head of Risk - NeoBank" },
  { id: 4, source: "Clutch", rating: "4.9", color: AVATAR_COLORS[3],
    content: '"AML screening used to take hours. With TrustEngine it\'s real-time. An absolute game changer for our compliance workflow."',
    name: "Michael Torres", designation: "Compliance Director - Finexa" },
  { id: 5, source: "G2",     rating: "5.0", color: AVATAR_COLORS[4],
    content: '"The sandbox environment let us test every edge case before go-live. TrustEngine\'s developer experience is best-in-class."',
    name: "Lisa Huang",     designation: "Lead Developer - SwiftPay" },
  { id: 6, source: "Clutch", rating: "5.0", color: AVATAR_COLORS[5],
    content: '"TrustEngine scales with us. We went from 10K to 5M monthly verifications without a single hiccup. Solid reliability and uptime."',
    name: "James Park",     designation: "CEO - TrustFi" },
];

const TestimonialSection: React.FC = () => {
  return (
    <section className="testimonial pb-150">
      <div className="container">
        <div className="sec-title sec-title-center tes-sec-title text-center mb-50">
          <span className="sub-title">Client Testimonials</span>
          <h2 className="title">Trusted by teams building at scale</h2>
        </div>
      </div>

      <div className="xb-testimonial-slider">
        <Swiper
          modules={[Autoplay]}
          loop={true}
          speed={400}
          spaceBetween={30}
          autoplay={{
            delay: 6000,
            disableOnInteraction: false,
          }}
          breakpoints={{
            1700: { slidesPerView: 5 },
            1600: { slidesPerView: 4 },
            1024: { slidesPerView: 3 },
            768: { slidesPerView: 2 },
            576: { slidesPerView: 1 },
            0: { slidesPerView: 1 },
          }}
        >
          {testimonials.map((item) => (
            <SwiperSlide key={item.id} style={{ height: "auto" }}>
              <div className="xb-testimonial-item" style={{ height: "100%" }}>
                <div className="xb-item--inner xb-border" style={{
                  height: "100%", display: "flex", flexDirection: "column",
                  background: "#ffffff",
                  boxShadow: "0 2px 20px rgba(15,32,64,0.07)",
                  border: "1px solid rgba(15,32,64,0.08)",
                  borderRadius: "16px", padding: "28px",
                  position: "relative", overflow: "hidden",
                }}>
                  {/* Decorative quote */}
                  <span style={{
                    position: "absolute", top: "16px", right: "20px",
                    fontSize: "80px", lineHeight: 1, color: "rgba(0,200,150,0.1)",
                    fontFamily: "Georgia, serif", fontWeight: 900, userSelect: "none",
                  }}>"</span>

                  {/* Source badge only */}
                  <div style={{ marginBottom: "16px" }}>
                    <span style={{
                      fontSize: "11px", fontWeight: 700, color: "#ffffff",
                      background: item.source === "G2" ? "#ef4444" : "#f97316",
                      padding: "2px 8px", borderRadius: "4px", letterSpacing: "0.05em",
                    }}>{item.source}</span>
                  </div>

                  {/* Quote text — grows to fill space */}
                  <p style={{
                    flex: 1, fontSize: "15px", lineHeight: "1.7", color: "#374151",
                    fontWeight: 500, margin: "0 0 24px", letterSpacing: "-0.01em",
                  }}>{item.content}</p>

                  {/* Author — always at bottom */}
                  <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                    <div style={{
                      width: "44px", height: "44px", borderRadius: "50%",
                      background: item.color, color: "#fff",
                      display: "flex", alignItems: "center", justifyContent: "center",
                      fontWeight: 700, fontSize: "15px", flexShrink: 0,
                    }}>
                      {item.name.split(" ").map(n => n[0]).join("")}
                    </div>
                    <div>
                      <div style={{ fontSize: "14px", fontWeight: 700, color: "#0f2040" }}>{item.name}</div>
                      <div style={{ fontSize: "12px", color: "#6b7280", marginTop: "2px" }}>{item.designation}</div>
                    </div>
                  </div>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </section>
  );
};

export default TestimonialSection;
